module.exports = __webpack_public_path__ + "images/color-fun-4-9618e8b8e7b4ed727d6ccefc51f70f16.jpg";